import type { Branding } from "@repo/shared"
import { useEffect, useState } from "react"

import { apiFetch } from "@/lib/api"

let cached: Branding | null = null
let pending: Promise<Branding | null> | null = null

function load(): Promise<Branding | null> {
  pending ??= apiFetch<Branding>("/branding")
    .then((value) => {
      cached = value

      return value
    })
    // The built-in logo and picture are the fallback, so a failure is not an error to show.
    .catch(() => null)
    .finally(() => {
      pending = null
    })

  return pending
}

/** Forget the loaded branding, so the next page picks up a change made in Settings. */
export function resetBranding() {
  cached = null
}

/**
 * The logo and pictures chosen in Settings, or null while loading or when none
 * could be loaded. Callers fall back to the built-in ones.
 */
export function useBranding(): Branding | null {
  const [branding, setBranding] = useState<Branding | null>(cached)

  useEffect(() => {
    if (cached) return

    let active = true

    void load().then((value) => {
      if (active && value) setBranding(value)
    })

    return () => {
      active = false
    }
  }, [])

  return branding
}
